import React, { FC, FormEvent, MouseEvent, ReactNode } from 'react';
import { BootstrapColorType, ButtonSizeType, ButtonVariantType } from '../../types/bootstrap.type';


type ButtonProps = {
    text: string;
    onClick: (e?: MouseEvent<HTMLButtonElement> | FormEvent<HTMLFormElement>) => void;
    theme?: BootstrapColorType | 'link';
    disabled?: boolean;
    size?: ButtonSizeType;
    endIcon?: ReactNode;
    type?: "button" | "submit" | "reset";
    title?: string;
    outline?: ButtonVariantType;
    isLoading?: boolean;
    show?: boolean;
}

const Button: FC<ButtonProps> = ({
    text,
    onClick,
    theme = 'primary',
    disabled = false,
    size = 'md',
    endIcon = null,
    type = "button",
    title = "",
    outline = 'solid',
    isLoading = false,
    show = true,
}) => {

    const classes = `btn btn-${outline === 'outline' ? 'outline-' : ''}${theme} btn-${size}`;

    if (!show) return null;

    return (
        <button
            disabled={disabled}
            type={type}
            title={title}
            onClick={e => onClick(e)}
            className={classes}
        >

            {(endIcon && !isLoading) && endIcon}

            {isLoading && (
                <span className={`spinner-border spinner-border-sm`} aria-hidden="true"></span>
            )}

            <span> {text} </span>

        </button>
    );

}

export default Button;